<template>
    <Admin
        :title="__('Newsletter', null, $page.props.profile_locale)"
    >

        <div class="flex flex-col items-start">
            <div class="space-x-3">
                <Button
                    :class="[
                        route().params.type == 'subscribers' ? 'opacity-50' : ''
                    ]"
                    :href="route(route().current())"
                    preserve-scroll
                >{{__('New message', null, $page.props.profile_locale)}}</Button>
                <Button
                    :class="[
                        route().params.type == 'subscribers' ? '' : 'opacity-50'
                    ]"
                    :href="route(route().current())"
                    preserve-scroll
                    :data="{ type: 'subscribers' }"
                >{{__('Subscribers', null, $page.props.profile_locale)}}</Button>
            </div>
            <div class="flex mt-4">
                <div
                    class="border-b px-4 cursor-pointer"
                    v-for="(item, key) in $page.props.languages"
                    :key="key"
                    :class="{
                        ['font-bold bg-gray-900 text-gray-200'] : send_form.active == key
                    }"
                    @click="send_form.active = key;"
                >
                    {{ key }} <span class="text-xs">({{ emails[key] ? emails[key].length : 0 }})</span>
                </div>
            </div>
        </div>

        <div class="overflow-auto w-full shadow-md rounded-md mt-3" v-if="route().params.type == 'subscribers'">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700">
                        <th class="px-4 py-3">{{__('#', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Email', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr
                        v-for="(item, key) in emails[send_form.active]"
                        :key="key"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                    >
                        <td class="px-4 py-2 font-bold">{{key + 1}}</td>
                        <td class="px-4 py-2">{{item.email}}</td>
                        <td class="px-4 py-2 flex">
                            <IconLink
                                icon="trash"
                                color="red"
                                class="py-1"
                                :href="route('newsletter.unsubscribe', { email: item.id, token: item.token, panel: true })"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            <div class="mt-4">
                <InputLabel
                    :label="__('Title', null, $page.props.profile_locale)"
                    type="text"
                    id="title"
                    class="mt-1 block w-full"
                    rows="2"
                    v-model="send_form.title"
                    required
                    autocomplete="title"
                >
                </InputLabel>
            </div>

            <div class="mb-16 mt-4">
            <InputLabel
                :label="__('Contents', null, $page.props.profile_locale)"
                type="quill"
                id="content"
                class="mt-1 block w-full h-80"
                rows="2"
                v-model="send_form.content"
                required
                autocomplete="content"
            >
            </InputLabel>
            </div>

            <div class="mt-20 flex">
                <Button
                    @click="sendEmails()"
                >
                    {{__('Send', null, $page.props.profile_locale)}}
                </Button>
            </div>
        </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import IconLink from 'UI/IconLink';

    import { useForm, usePage } from '@inertiajs/inertia-vue3'

    export default {
        props: {
            emails: [Array, Object],
        },
        components: {
            Admin, Button, SvgIcon, InputLabel, IconLink
        },
        setup(props) {
            const send_form = useForm({
                title: null,
                content: null,
                active: usePage().props.value.locale,
            })

            const sendEmails = () => {
                send_form.post(route('send.emails'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        send_form.reset('title', 'content');
                    },
                });
            }

            return {
                send_form,
                sendEmails,
            }
        },

    }
</script>
